export default "__VITE_ASSET__Blb63DTO__"